import React, { useEffect, createElement } from 'react';
export function ChatbotWidget() {
  useEffect(() => {
    // Check if script is already loaded to prevent duplicates
    if (!document.getElementById('omnidimension-web-widget')) {
      const script = document.createElement('script');
      script.id = 'omnidimension-web-widget';
      script.src = 'https://omnidim.io/web_widget.js?secret_key=73d4192fc04fcad4e4b7f5b4ae78e9ab';
      script.async = true;
      document.body.appendChild(script);
    }
    return () => {
      // Cleanup if needed, though usually chatbots stay across navigation
      // We'll leave it in the DOM to avoid re-initializing on every route change
    };
  }, []);
  return <div id="omni-widget-component" className="fixed bottom-24 right-6 z-40 md:bottom-6 md:right-24" style={{
    width: '0',
    height: '0'
  }} // The script will inject its own UI, we just need the container
  data-id="element-45"></div>;
}